import React, { Component } from 'react'

export class ToggleButton extends Component {
    render() {
        return (
            <div className="flex-center switchcon">
                <label className="switch">
                    <input type="checkbox" checked={this.props.checked} onChange={this.props.onChange} />
                    <span className="slider round1"></span>
                </label>
                Pick me
            </div>
        )
    }
}

